module.exports = __webpack_public_path__ + "img/sbg1.c0f631ab.png";